import { Injectable } from '@angular/core';

import { Subject, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReloadMapService {
  private reload$ = new Subject<boolean>();

  getReload() {
    return this.reload$.asObservable();
  }

  setReloadStatus(status: boolean) {
    this.reload$.next(!!status);
  }

  reinitializeMap() {
    of(null)
      .pipe(
        tap(() => this.setReloadStatus(false)),
        delay(0),
        tap(() => this.setReloadStatus(true)),
      ).subscribe();
  }
}
